import React, { useContext, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../imageService';
import InputMask from 'react-input-mask';
import classNames from 'classnames';
import apiService from '../../../../utils/apiService';
import { DataLayerEventContext } from '../../../../contexts/dataLayerEventContext';

const PhoneScreen = ({
  setScreenNumber,
  handleNextScreen,
  isVisibleModal,
  setIsVisibleModal,
  isDarkMode = false
}) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    sendEvent('phone_seen_authorization');
  }, []);

  const handleCheckPhone = () => {
    const regex = /^380\d{9}$/;
    const updatedPhone = phone.replace(/\D/g, '').replace(/^380/, '380');

    if (!regex.test('380' + updatedPhone)) setPhoneError(true);

    return regex.test('380' + updatedPhone);
  };

  const handleNext = async () => {
    if (isSubmitting) return;
    const isValid = handleCheckPhone();

    if (!isValid) return;

    try {
      setIsSubmitting(true);
      const formattedPhone = '380' + phone.replace(/\D/g, '');
      sessionStorage.setItem('p_n', formattedPhone);

      await apiService.post('test/registration/otp', {
        data: {
          phone: formattedPhone
        }
      });

      handleNextScreen();
    } catch (error) {
      console.error('Error sending OTP:', error);
      console.log('Error response:', error.response?.data);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className={classNames(styles.container, isDarkMode && styles.darkMode)}
      style={{
        backgroundImage: isDarkMode
          ? null
          : `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div className={styles.content}>
        <p className={styles.title}>Найцікавіше близько!</p>
        <p className={styles.description}>
          Введи номер телефону для авторизації.
          <br></br>P.S. Обіцяємо нудно не буде 😁
        </p>
        <div className={styles.phoneInputContainer}>
          <div className={styles.labelContainer}>
            <p>Код</p>
            <p>Номер телефону*</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.codeContainer}>+380</div>
            <InputMask
              mask="(99) 999-99-99"
              maskChar="_"
              alwaysShowMask
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onFocus={() => setPhoneError(false)}
              onBlur={handleCheckPhone}
              className={classNames(
                styles.input,
                phoneError && styles.errorInput
              )}
            >
              {(inputProps) => <input {...inputProps} type="tel" />}
            </InputMask>
            {phoneError && (
              <i className={styles.phoneErrorIcon}>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_0_76)">
                    <circle cx="14" cy="10" r="10" fill="#F9524D" />
                    <path
                      d="M14.9444 5L14.7407 12.555H13.2593L13.0494 5H14.9444ZM13 14.894C13 14.5752 13.0905 14.3111 13.2716 14.1019C13.4568 13.8877 13.6996 13.7806 14 13.7806C14.3045 13.7806 14.5473 13.8877 14.7284 14.1019C14.9095 14.3111 15 14.5752 15 14.894C15 15.2029 14.9095 15.4644 14.7284 15.6787C14.5473 15.8929 14.3045 16 14 16C13.6996 16 13.4568 15.8929 13.2716 15.6787C13.0905 15.4644 13 15.2029 13 14.894Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_0_76"
                      x="0"
                      y="0"
                      width="28"
                      height="28"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_0_76"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_0_76"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </i>
            )}
          </div>
          {phoneError && (
            <p className={styles.error}>Перевір коректність вказаного номеру</p>
          )}
        </div>
        {isDarkMode ? (
          <button
            className={styles.darkModeNextButton}
            onClick={handleNext}
            disabled={isSubmitting}
          >
            <img src="/images/gold-button.png" alt="gold-button" />
            {isSubmitting && <span className={styles.spinner} />}
            <span>Далі</span>
          </button>
        ) : (
          <button
            className={styles.nextButton}
            onClick={handleNext}
            disabled={isSubmitting}
          >
            {isSubmitting && <span className={styles.spinner} />}
            <span>Далі</span>
          </button>
        )}
        <div
          className={classNames(
            styles.footer,
            isDarkMode ? styles.darkFooter : ''
          )}
        >
          Натискаючи «ДалI» ти робиш запит на отримання інформації про продукцію
          компанії Філіп Морріс засобами дистанційного зв'язку відповідно до
          частини 2 статті 15 Закону «Про захист прав споживачів» та
          підтверджуєш, що Є СПОЖИВАЧЕМ ТЮТЮНОВИХ ВИРОБІВ ТА/АБО КОРИСТУВАЧЕМ
          ПРИСТРОЇВ ДЛЯ СПОЖИВАННЯ ТЮТЮНОВИХ ВИРОБІВ БЕЗ ЇХ ЗГОРЯННЯ“.
        </div>
        {/*<button className={styles.skipButton}>Пропустити</button>*/}
      </div>
      <div className={styles.buttonContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(2)}>Умови використання</button>
        <button onClick={() => setScreenNumber(3)}>FAQ</button>
        <button onClick={() => setScreenNumber(4)}>
          Параметри застосування файлів cookie
        </button>
      </div>
      {isVisibleModal && (
        <div
          className={classNames(styles.modal, isDarkMode && styles.darkModal)}
        >
          <p className={styles.text}>
            Ми використовуємо файли cookie та подібні технології для надання
            персоналізованого досвіду (відповідно до вашої поведінки в Інтернеті
            на цьому та інших веб-сайтах), для релевантного відображення
            оголошень, контенту і доречної комунікації; для поліпшення сайту;
            роботи сайту; і щоб пам'ятати ваші уподобання. Натисніть «Дізнатися
            більше» для отримання додаткової інформації або для налаштування
            параметрів. Ви можете змінити свою думку в будь-який час, відвідавши
            «Налаштування файлів cookie». Будь-які ваші персональні дані будуть
            використовуватися, як описано в нашій
          </p>
          <a
            className={styles.policyLink}
            href="https://www.pmiprivacy.com/ukraine/uk/consumer/"
          >
            Політиці конфіденційності
          </a>
          <div className={styles.buttonContainer}>
            <button onClick={() => setIsVisibleModal(false)}>
              Погоджуюся з усім
            </button>
            <button
              onClick={() => {
                setIsVisibleModal(false);
                setScreenNumber(4);
              }}
            >
              Дізнатися більше
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhoneScreen;
